import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';

function CustomerIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state        
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new customer
    const [Name, setName] = useState('');
    const [AddressLine1, setAddressLine1] = useState('');
    const [AddressLine2, setAddressLine2] = useState('');
    const [ContactNumber1, setContactNumber1] = useState('');
    const [ContactNumber2, setContactNumber2] = useState('');
    const [VATNumber, setVATNumber] = useState('');
    const [PostalCode, setPostalCode] = useState('');
    const [OpeningBalance, setOpeningBalance] = useState('0');
    const [IsPayableOrReceivable, setIsPayableOrReceivable] = useState(false);

    // Optimized input handlers with useCallback
    const handleNameChange = useCallback((e) => setName(e.target.value), []);
    const handleAddressLine1Change = useCallback((e) => setAddressLine1(e.target.value), []);
    const handleAddressLine2Change = useCallback((e) => setAddressLine2(e.target.value), []);
    const handleContactNumber1Change = useCallback((e) => setContactNumber1(e.target.value), []);
    const handleContactNumber2Change = useCallback((e) => setContactNumber2(e.target.value), []);
    const handleVATNumberChange = useCallback((e) => setVATNumber(e.target.value), []);
    const handlePostalCodeChange = useCallback((e) => setPostalCode(e.target.value), []);
    const handleOpeningBalanceChange = useCallback((e) => setOpeningBalance(e.target.value), []);
    const handleIsPayableOrReceivableChange = useCallback((e) => setIsPayableOrReceivable(e.target.checked), []);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    // Debounce search query to improve performance
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchQuery(searchQuery);
        }, 300); // 300ms delay

        return () => clearTimeout(timer);
    }, [searchQuery]);

    //search - optimized with useCallback and useMemo
    const handleSearch = useCallback((event) => {
        setSearchQuery(event.target.value);
    }, []);

    const toggleSearchInput = useCallback(() => {
        setShowSearchInput(!showSearchInput);
    }, [showSearchInput]);

    // Memoized filtered data to prevent unnecessary recalculations
    const filteredData = useMemo(() => {
        if (!debouncedSearchQuery.trim()) return data;
        
        const lowercaseQuery = debouncedSearchQuery.toLowerCase();
        return data.filter((item) =>
            Object.values(item).some((value) =>
                String(value).toLowerCase().includes(lowercaseQuery)
            )
        );
    }, [data, debouncedSearchQuery]);
    const [isFocused, setIsFocused] = useState(false);
    const fetchtableData = async () => {
        setLoading(true);
        fetchData('CustomerApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching CustomerApi:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('CustomerApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);

                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = useCallback((itemId) => {
        activateData('CustomerApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    }, []);

    const openConfirmDialog = useCallback((itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    }, []);

    const closeConfirmDialog = useCallback(() => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    }, []);

    const toggleModal = useCallback(() => {
        setIsModalOpen(!isModalOpen);
    }, [isModalOpen]);


    const addGroupRecord = async (e) => {
        e.preventDefault();
        setIsLoading(true); // show loader

        if (!Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        // ✅ Check duplicate by comparing case-insensitive
        const isDuplicate = data.some(
            (item) => item.Name.trim().toLowerCase() === Name.trim().toLowerCase()
        );

        if (isDuplicate) {
            setErrorMessage("This Customer Name already exists!");
            setIsLoading(false);
            return;
        }

        const Customer = {
            CompanyId: companyId,
            Name,
            AddressLine1,
            AddressLine2,
            ContactNumber1,
            ContactNumber2,
            VATNumber,
            PostalCode,
            IsPayableOrReceivable,
            OpeningBalance,
            IsActive: true,
            CreatedBy: userId,
            CreatedDate: new Date(),
        };

        postData('CustomerApi', Customer, token)
            .then((response) => {
                console.log('Customer Created success:', response);
                setSuccessMessage("Customer Created successfully!");
                setErrorMessage("");
                setName("");
                setAddressLine1("");
                setAddressLine2("");
                setContactNumber1("");
                setContactNumber2("");
                setVATNumber("");
                setPostalCode("");
                setOpeningBalance("0");
                setIsPayableOrReceivable(false);

                setIsModalGrpOpen(false);
                window.location.reload();

                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Customer Create error:', error);
            })
            .finally(() => {
                setIsLoading(false); // hide loader
            });
    };


    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = useCallback(async (Id) => {
        try {
            const response = await fetchData('CustomerApi', `/MasterDetails/${Id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    }, [token]);

    // master Group model


    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const toggleModalGroup = useCallback(() => {
        setIsModalGrpOpen(!isModalGrpOpen);
    }, [isModalGrpOpen]);

    const toggleModalGrp2 = useCallback(() => {
        setIsDetailModalOpen(false); // Step 2
    }, []);
    const handleUpdateInputChange = useCallback((event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    }, []);

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsUpdateLoading(true); // start loading

        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsUpdateLoading(false);
            return;
        }

        try {
            await updateData('CustomerApi', `${updatedData.Id}`, updatedData, token);

            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });

            window.location.reload();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        } finally {
            setIsUpdateLoading(false); // stop loading
        }
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>CUSTOMER</h6>
                {/* {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                 */}
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '10px', fontSize: '14px' }}>
                            Loading...
                        </span>
                    </div>
                )}

                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>

                <Tooltip
                    title="Customer Registration" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(to right, #041815ff, #045157ff)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleModalGroup}
                        className="linkcolor"
                    >
                        ADD CUSTOMER
                    </Button>
                </Tooltip>
            </div>

            {isModalGrpOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                    {/* <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto"> */}
                    {/* <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                    transform transition-transform duration-500 ease-out translate-y-[-100vh] animate-slideIn"
                    > */}
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                        animate-zoomIn"
                    >
                        <h6 className="text-center text-black font-bold mb-4" style={{ fontFamily: 'Times New Roman', fontFamily: 'Times New Roman', fontWeight: 'bolder' }}>
                            CUSTOMER REGISTRATION
                        </h6>

                        {errorMessage && <p className="text-red-500 mb-2">{errorMessage}</p>}

                        <form onSubmit={addGroupRecord}>
                            <div className="flex flex-col gap-3">
                                <div>
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Name<span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={Name}
                                        onChange={handleNameChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Enter Name"
                                    />
                                </div>

                                <div>
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Address Line 1</label>
                                    <input
                                        type="text"
                                        value={AddressLine1}
                                        onChange={handleAddressLine1Change}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Address Line 1"
                                    />
                                </div>

                                <div>
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Address Line 2</label>
                                    <input
                                        type="text"
                                        value={AddressLine2}
                                        onChange={handleAddressLine2Change}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Address Line 2"
                                    />
                                </div>

                                <div className="flex gap-3">
                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">Contact Number 1</label>
                                        <input
                                            type="text"
                                            value={ContactNumber1}
                                            onChange={handleContactNumber1Change}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="Contact Number 1"
                                        />
                                    </div>

                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">Contact Number 2</label>
                                        <input
                                            type="text"
                                            value={ContactNumber2}
                                            onChange={handleContactNumber2Change}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="Contact Number 2"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">VAT Number</label>
                                        <input
                                            type="text"
                                            value={VATNumber}
                                            onChange={handleVATNumberChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="VAT Number"
                                        />
                                    </div>

                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">Postal Code</label>
                                        <input
                                            type="text"
                                            value={PostalCode}
                                            onChange={handlePostalCodeChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="Postal Code"
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-between items-center mt-1">
                                    {/* Opening Balance + Checkbox */}
                                    <div className="flex items-center gap-4">
                                        <div>
                                            <label className="block uppercase tracking-wide text-xs font-bold mb-2">
                                                Opening Balance
                                            </label>
                                            <input
                                                type="number"
                                                value={OpeningBalance}
                                                onChange={handleOpeningBalanceChange}
                                                className="shadow appearance-none border rounded w-32 py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                                placeholder="Opening Balance"
                                            />
                                        </div>

                                        <div className="flex items-center gap-2 mt-6">
                                            <input
                                                type="checkbox"
                                                checked={IsPayableOrReceivable}
                                                onChange={handleIsPayableOrReceivableChange}
                                                id="isPayableOrReceivable"
                                                className="h-4 w-4"
                                            />
                                            <label
                                                htmlFor="isPayableOrReceivable"
                                                className="text-gray-700 text-xs font-bold"
                                            >
                                                Is Payable / Receivable
                                            </label>
                                        </div>
                                    </div>

                                    <div className="flex mt-4" style={{ justifyContent: 'center' }}>
                                        {/* Add Record Button */}
                                        <button
                                            onClick={addGroupRecord}
                                            style={{
                                                backgroundColor: '#088b11ff',
                                                color: '#ffffff',
                                                padding: '6px 12px',
                                                fontSize: '13px',
                                                height: '32px',
                                                borderRadius: '6px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                transition: 'transform 0.15s ease, background-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'scale(1.04)';
                                                e.target.style.backgroundColor = '#1e9304ff';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                                e.target.style.backgroundColor = '#09a628ff';
                                            }}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <CircularProgress size={16} color="inherit" />
                                                    Saving...
                                                </>
                                            ) : (
                                                "Add Record"
                                            )}
                                        </button>

                                        {/* Cancel Button */}
                                        <button
                                            onClick={toggleModalGroup}
                                            style={{
                                                backgroundColor: '#64748b',
                                                color: '#ffffff',
                                                padding: '6px 12px',
                                                fontSize: '13px',
                                                height: '32px',
                                                borderRadius: '6px',
                                                border: 'none',
                                                marginLeft: '8px',
                                                cursor: 'pointer',
                                                transition: 'transform 0.15s ease, background-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'scale(1.04)';
                                                e.target.style.backgroundColor = '#475569';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                                e.target.style.backgroundColor = '#64748b';
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            )
            }

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70', padding: '2px' }}>

                            <TableRow>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Sl.No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Name
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Contact No 1
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Contact No 2
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    VAT No
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                    Postal Code
                                </TableCell>
                                <TableCell
                                    style={{
                                        background: 'linear-gradient(to right, #173B45, #173B45)', borderRadius: '5px', color: 'white',
                                        fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'center', position: 'sticky',
                                        top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase'
                                    }}>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <CustomerTableRow 
                                    key={item.Id || item.id} 
                                    item={item} 
                                    index={index}
                                    onEdit={openDetailModal}
                                    onDelete={openConfirmDialog}
                                    onActivate={handleActivate}
                                />
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>

                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
                        {/* <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto"> */}
                        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                        animate-zoomIn"
                        >
                            <h6 style={{ color: '#110441ff', textAlign: 'center', fontWeight: 'bolder', fontFamily: 'Times New Roman' }}>CUSTOMER EDIT</h6>
                            {errorMessageEdit && <p className="text-red-500">{errorMessageEdit}</p>}

                            <div className="flex flex-col gap-3">
                                <div>
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Name<span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        name="Name"
                                        value={updatedData.Name}
                                        onChange={handleUpdateInputChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Enter Name"
                                    />
                                </div>

                                <div>
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Address Line 1</label>
                                    <input
                                        type="text"
                                        name="AddressLine1"
                                        value={updatedData.AddressLine1}
                                        onChange={handleUpdateInputChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Address Line 1"
                                    />
                                </div>

                                <div>
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2">Address Line 2</label>
                                    <input
                                        type="text"
                                        name="AddressLine2"
                                        value={updatedData.AddressLine2}
                                        onChange={handleUpdateInputChange}
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                        placeholder="Address Line 2"
                                    />
                                </div>

                                <div className="flex gap-3">
                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">Contact Number 1</label>
                                        <input
                                            type="text"
                                            name="ContactNumber1"
                                            value={updatedData.ContactNumber1}
                                            onChange={handleUpdateInputChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="Contact Number 1"
                                        />
                                    </div>

                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">Contact Number 2</label>
                                        <input
                                            type="text"
                                            name="ContactNumber2"
                                            value={updatedData.ContactNumber2}
                                            onChange={handleUpdateInputChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="Contact Number 2"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">VAT Number</label>
                                        <input
                                            type="text"
                                            name="VATNumber"
                                            value={updatedData.VATNumber}
                                            onChange={handleUpdateInputChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="VAT Number"
                                        />
                                    </div>

                                    <div className="flex-1">
                                        <label className="block uppercase tracking-wide text-xs font-bold mb-2">Postal Code</label>
                                        <input
                                            type="text"
                                            name="PostalCode"
                                            value={updatedData.PostalCode}
                                            onChange={handleUpdateInputChange}
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                            placeholder="Postal Code"
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-between items-center mt-1">
                                    {/* Opening Balance + Checkbox */}
                                    <div className="flex items-center gap-4">
                                        <div>
                                            <label className="block uppercase tracking-wide text-xs font-bold mb-2">
                                                Opening Balance
                                            </label>
                                            <input
                                                type="number"
                                                name="OpeningBalance"
                                                value={updatedData.OpeningBalance}
                                                onChange={handleUpdateInputChange}
                                                className="shadow appearance-none border rounded w-32 py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
                                                placeholder="Opening Balance"
                                            />
                                        </div>

                                        {/* Checkbox */}
                                        <div className="flex items-center gap-2 mt-6">
                                            <input
                                                type="checkbox"
                                                name="IsPayableOrReceivable"
                                                checked={updatedData.IsPayableOrReceivable || false}
                                                onChange={(e) =>
                                                    handleUpdateInputChange({
                                                        target: {
                                                            name: "IsPayableOrReceivable",
                                                            value: e.target.checked,
                                                        },
                                                    })
                                                }
                                                className="h-4 w-4"
                                            />
                                            <label
                                                htmlFor="isPayableOrReceivable"
                                                className="text-gray-700 text-xs font-bold"
                                            >
                                                Is Payable / Receivable
                                            </label>
                                        </div>
                                    </div>

                                    {/* Buttons */}
                                    <div className="flex gap-2">
                                        <button
                                            onClick={updateRecord}
                                            style={{
                                                backgroundColor: '#b35e15ff',
                                                color: '#ffffff',
                                                padding: '6px 12px',
                                                fontSize: '13px',
                                                height: '32px',
                                                borderRadius: '6px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                transition: 'transform 0.15s ease, background-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'scale(1.04)';
                                                e.target.style.backgroundColor = '#b06a0dff';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                                e.target.style.backgroundColor = '#a66f09ff';
                                            }}
                                        >
                                            {isUpdateLoading ? (
                                                <>
                                                    <CircularProgress size={16} color="inherit" />
                                                    Updating...
                                                </>
                                            ) : (
                                                "Update Record"
                                            )}
                                        </button>

                                        {/* Cancel Button */}
                                        <button
                                            onClick={toggleModalGrp2}
                                            style={{
                                                backgroundColor: '#64748b',
                                                color: '#ffffff',
                                                padding: '6px 12px',
                                                fontSize: '13px',
                                                height: '32px',
                                                borderRadius: '6px',
                                                border: 'none',
                                                marginLeft: '8px',
                                                cursor: 'pointer',
                                                transition: 'transform 0.15s ease, background-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'scale(1.04)';
                                                e.target.style.backgroundColor = '#475569';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'scale(1)';
                                                e.target.style.backgroundColor = '#64748b';
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>
                )}
            </div>
        </div >
    );
}

// Memoized table row component to prevent unnecessary re-renders
const CustomerTableRow = React.memo(({ item, index, onEdit, onDelete, onActivate }) => (
    <TableRow
        sx={{
            '&:hover': { backgroundColor: '#F1E7E7' },
            transition: 'background-color 0.3s ease-in-out',
            cursor: 'pointer',
        }}
    >
        <TableCell sx={{ padding: '2px', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{index + 1}</TableCell>
        <TableCell sx={{ padding: '2px', width: '30%', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.Name}</TableCell>
        <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.ContactNumber1}</TableCell>
        <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.ContactNumber2}</TableCell>
        <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.VATNumber}</TableCell>
        <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.PostalCode}</TableCell>
        <TableCell sx={{ padding: '2px', textAlign: 'right', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>
            <Tooltip
                title="Customer Edit" arrow
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#110441ff',
                            color: 'white',
                            border: '1px solid white',
                            fontWeight: 'bold',
                            boxShadow: 2,
                        },
                    },
                }}
            >
                <IconButton onClick={() => onEdit(item.Id)}>
                    <EditIcon style={{ color: '#110441ff', fontSize: '17px' }} />
                </IconButton>
            </Tooltip>
            <Tooltip
                title="Customer Delete" arrow
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: '#DA6C6C',
                            color: 'white',
                            border: '1px solid white',
                            fontWeight: 'bold',
                            boxShadow: 2,
                        },
                    },
                }}
            >
                <IconButton onClick={() => (item.IsActive ? onDelete(item.Id) : onActivate(item.Id))}>
                    {item.IsActive ? <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} /> : <ActivateIcon />}
                </IconButton>
            </Tooltip>
        </TableCell>
    </TableRow>
));

export default CustomerIndex;
